module.exports = __webpack_public_path__ + "static/media/view staff short leave.f5fb2cc8.svg";